<template>
  <gjw-dialog
    title="降级"
    :show-dialog="dialogVisible"
    :config="{ width: '480px' }"
    @close="closeDialog">
    <div>
      <el-form label-width="110px" label-suffix="：" label-position="left">
        <el-form-item label="操作构件">
          <div class="text-ellipsis" :title="componentInfo?.name +'.'+ componentInfo?.suffix">{{ componentInfo?.name }}.{{ componentInfo?.suffix }}</div>
        </el-form-item>
        <el-form-item label="当前软件版本">
          <span>{{ componentInfo?.softwareVersion }}</span>
        </el-form-item>
        <el-form-item label="降级为">
          <el-radio-group v-model="targetSoftwareVersion">
            <el-radio v-for="item in softwareVersionList" :label="item" :key="item">{{ item }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="tooltip-container">
        <div>提示</div>
        <div>
          <span>1、由于版本间兼容问题，降级过程中不保留形体约束关系，可能存在信息丢失；</span>
        </div>
        <div>
          <span>2、降级需要一定时间，请耐心等待，降级完成后，新的构件文件(原文件名_指定版本）将存到原构件文件所在路径。</span>
        </div>
      </div>
    </div>
    <template #customFooter>
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="$emit('confirm', componentInfo, targetSoftwareVersion)">开始降级</el-button>
    </template>
  </gjw-dialog>
</template>

<script>
export default {
  data() {
    return {
      softwareVersionList: [],
      targetSoftwareVersion: '',
      componentInfo: {}
    }
  },
  props: {
    dialogVisible: {
      type: Boolean
    },
    form: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    init(row) {
      this.componentInfo = row
      this.softwareVersionList = ['2022', '2021', '2020', '2019', '2018', '2017', '2016']
      const validStartIndex = this.softwareVersionList.indexOf(this.componentInfo?.softwareVersion) + 1
      this.softwareVersionList = this.softwareVersionList.slice(validStartIndex)
      this.targetSoftwareVersion = this.softwareVersionList[0]
    },
    closeDialog() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
.el-radio-group {
  vertical-align: baseline;
  .el-radio {
    margin-top: 10px;
    margin-right: 20px;
    height: 20px;
  }
}

.el-dialog__footer {
  border-top: 1px solid @border-color;
}
.tooltip-container {
  border-radius: 4px;
  background: @bg-grey-light;
  padding: 8px 12px 10px;
  line-height: 1.5;
  color: rgba(73, 95, 112, 0.6);
}

.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 330px;
}

.el-form {
  margin-bottom: 22px;
}
.el-form-item--small.el-form-item {
  margin-bottom: 10px;
}
</style>
